import BlessButton from "@/components/layout/button/green-outline-btn";
import { useModularPermissionsStore } from "@/features/mod-perms/stores/modular-permissions.store";
import React from "react";
import { BiPlus } from "react-icons/bi";
import { useAccount } from "wagmi";
import styles from "../action-btns.module.scss";
import classNames from "classnames";

type Props = {};

const AddBtn = (props: Props) => {
  const { isDelegateContextGranted, startDelegateCreation } =
    useModularPermissionsStore();
  const account = useAccount();
  if (isDelegateContextGranted() && account.isConnected)
    return (
      <button
        className={classNames(styles.actionBtn, styles.addBtn)}
        onClick={startDelegateCreation}
      >
        <BiPlus size={20} /> <span>Add</span>
      </button>
    );
};

export default AddBtn;
